import { locationIdFormat } from "@redotech/redo-inventory-id";
import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const setLocationLinkedReturnsCenter = unaryRpc({
  name: "setLocationLinkedReturnsCenter" as const,
  input: z.object({
    teamId: z.string(),
    locationId: locationIdFormat.schema,
    linkedReturnsCenterId: returnsCenterIdFormat.schema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
});
